import { useContext } from 'react';
//@ts-ignore
import { reload } from '@mindtickle/utils';

import { getApplicationAccessLink, APPLICATIONS } from '~/components/ApplicationUrls';
import { LocalAuthContext } from './LocalAuthProvider';

function RequiresAuth({ children }: { children: JSX.Element }) {
  let auth = useContext(LocalAuthContext);

  if (!auth?.user?.isLoggedIn) {
    reload(getApplicationAccessLink(APPLICATIONS.LOGIN), { replace: true });
    return null;
  }

  return children;
}

export default RequiresAuth;
